import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function ResponseTimeAnalysis() {
  const data = [
    { week: "Week 1", avgResponse: 4.2, target: 3.0 },
    { week: "Week 2", avgResponse: 3.8, target: 3.0 },
    { week: "Week 3", avgResponse: 5.1, target: 3.0 },
    { week: "Week 4", avgResponse: 3.5, target: 3.0 },
    { week: "Week 5", avgResponse: 4.7, target: 3.0 },
    { week: "Week 6", avgResponse: 3.2, target: 3.0 },
    { week: "Week 7", avgResponse: 2.9, target: 3.0 },
    { week: "Week 8", avgResponse: 4.1, target: 3.0 }
  ];

  return (
    <div className="chart-card">
      <div className="chart-card__header">
        <h3 className="chart-card__title">Response Time Analysis</h3>
        <p className="chart-card__subtitle">Average response time vs target SLA</p>
      </div>
      <div className="chart-card__content">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="week" stroke="#6b7280" fontSize={12} />
            <YAxis stroke="#6b7280" fontSize={12} />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'white', 
                border: 'none', 
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', 
                borderRadius: '8px' 
              }} 
            />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="avgResponse" 
              stroke="#0B7AFF" 
              strokeWidth={2} 
              name="Avg Response Time (hours)"
              dot={{ fill: '#0B7AFF', strokeWidth: 2, r: 4 }}
            />
            <Line 
              type="monotone" 
              dataKey="target" 
              stroke="#EF4444" 
              strokeWidth={2} 
              strokeDasharray="5 5" 
              name="Target SLA"
              dot={{ fill: '#EF4444', strokeWidth: 2, r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
